export const SET_QUIZ = "QUIZZES/SET_QUIZ";
